import React, { useState } from "react"
import { useNavigate } from "react-router"
import { useSelector, useDispatch } from "react-redux"
import { Button, Form, Input, Select, Tag } from "antd"

// Components
import showSecondarySidebar from "../../../../../../layout/MainLayout/helpers/showSecondarySidebar"
import Page from "../../../../../../components/Decoration/Page"

// Services Library
import { REDUX } from "../../../../../../services/util"

// Redux Actions
import * as REDUX_ACTIONS from '../../../../../../services/redux/actions'

// Style
import styles from '../UserEditForm/index.module.css'

const UserAddForm = () => {

    // const title = data?.title || 'Create'

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [ form ] = Form.useForm()

    const user = useSelector(REDUX.reduxStoreWrapper('user'))
    const userList = useSelector(REDUX.reduxStoreWrapper('userHierarchy.byID'))
    const userRoles = useSelector(REDUX.reduxStoreWrapper('userRoles.byID'))
    const vehicleGroups = useSelector(REDUX.reduxStoreWrapper('vehicleGroups'))
    const vehicles = useSelector(REDUX.reduxStoreWrapper('vehicles.staticsByID'))
    const loading = useSelector(REDUX.reduxStoreWrapper('style.loading.user'))

    const [ svhcgids, setSvhcgids ] = useState([]) 

    const userListOptions = Object.values(userList).map(ul => ({
        label: ul.name,
        value: ul.uid
    }))
    const userRoleOptions = Object.values(userRoles)
        ?.filter(ur => ur.hierarchy > userRoles[user.uroleid].hierarchy)
        ?.map(urole => ({
            label: urole.roleName,
            value: urole.uroleid
        }))
    const vehicleGroupOptions = (vehicleGroups?.relationByUID?.[user?.uid] || [])
    ?.map(vg => ({
        label: vehicleGroups?.byID[vg]?.name,
        value: vehicleGroups?.byID[vg]?.vhcgid
    }))

    const vehicleArrs = svhcgids?.map(vhcgid => vehicleGroups.byID[vhcgid]?.vehicles)?.flatMap(v => v)
    const noDuplicatedVehicleArrs = [ ...new Set(vehicleArrs) ]?.filter(v => vehicles[v]?.status)

    const onFinish = (e) => {

        delete e.confirmPassword

        const items = {
            userInfo: {
                ...e,
                contact: `${e.contactPrefix}-${e.contact}`,
            },
            preHierCode: user.hierCode,
            vhcgids: e.vhcgids
        }

        delete items.userInfo.contactPrefix
        delete items.userInfo.vhcgids

        dispatch(REDUX_ACTIONS.v3_userHierarchy.user_profile_create_request(items, () => {
            navigate(`/management/user`)
        }))

    }

    const ContactPrefix = (
        <Form.Item name={'contactPrefix'} noStyle>
            <Select options={[ { value: '+60', label: '+60' } ]} />
        </Form.Item>
    )
    
    return (
        <div className="page-container">
            <Page title={`Add New User`}>
                <Form 
                    style={{ width: '50vw', minWidth: '60em', margin: '5em auto'}}
                    labelCol={{ span: 5 }}
                    form={form}
                    onFinish={onFinish}
                    initialValues={{
                    //     ...data,
                    //     imei: data?.dvid?.split('#')[1],
                        contactPrefix: '+60',
                    //     contact: data?.contact?.split('-')[1]
                    }}
                >
                    <Form.Item
                        label="User Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: 'Please input user name!',
                            },
                        ]}
                        >
                            {/* <Select size="large" options={userListOptions} /> */}
                            <Input options={userListOptions} />
                        </Form.Item>
                        <Form.Item
                            label="Email Address"
                            name="email"
                            rules={[
                                {
                                    type: 'email'
                                },
                                {
                                    required: true,
                                    message: 'Please input vehicle email address!',
                                },
                            ]}
                        >
                            <Input size="large "/>
                        </Form.Item>
                        <Form.Item
                            label="User Role"
                            name="uroleid"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input user role!',
                                },
                            ]}
                        >
                            <Select options={userRoleOptions} size="large "/>
                        </Form.Item>
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input user password!',
                                },
                                // {
                                //     pattern: /^(?:\+60|60|0)(?:1[0-46-9][0-9]{7,8}|[3-9][0-9]{7,8})$/,
                                //     message: 'Please input phone number'
    
                                // }
                            ]}
                        >
                            <Input.Password size="large" />
                        </Form.Item>
                        <Form.Item
                            label="Confirm Password"
                            name="confirmPassword"
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input confirm password!',
                                },
                                ({ getFieldValue }) => ({

                                    validator(_, value) {

                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }

                                        return Promise.reject(new Error('The new password that you entered do not match!'));                            
                                    }

                                })
                            ]}
                        >
                            <Input.Password size="large" />
                        </Form.Item>
                        <Form.Item
                            label="Contact Number"
                            name="contact"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input driver contact!',
                                },
                                // {
                                //     pattern: /^(?:\+60|60|0)(?:1[0-46-9][0-9]{7,8}|[3-9][0-9]{7,8})$/,
                                //     message: 'Please input phone number'
    
                                // }
                            ]}
                            >
                                <Input addonBefore={ContactPrefix} size="large" />
                            </Form.Item>
                        <Form.Item
                            label="Office Address"
                            name="address"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input address!',
                                },
                            ]}
                            >
                                <Input size="large" />
                            </Form.Item>
                        <Form.Item
                            label="Vehicle Group"
                            name="vhcgids"
                            // rules={[
                            //     {
                            //         required: true,
                            //         message: 'Please input vehicle group!',
                            //     },
                            // ]}
                        >
                            <Select 
                                mode='multiple' size="large" 
                                options={vehicleGroupOptions} 
                                onChange={e => setSvhcgids(e)} 
                                tagRender={({ value, label, closable, onClose }) => 
                                    <Tag 
                                        color={vehicleGroups.byID[value]?.color}
                                        closable={closable}
                                        onClose={onClose}                                  
                                    >
                                        {label}
                                    </Tag>}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Vehicle Selected"
                        >
                            {
                                noDuplicatedVehicleArrs?.length && noDuplicatedVehicleArrs.map((vhc, i) => <h4 key={i}>{i + 1}. {vehicles[vhc]?.plate}</h4>) || ''
                            }
                        </Form.Item>

                        <div className={styles['button-container']}>
                            <Button className={`${styles['button']} ${styles['cancel']}`} onClick={() => navigate(-1)}>Cancel</Button>
                            <Button className={`${styles['button']} ${styles['add']}`} loading={loading} htmlType="submit">{'Save'}</Button>
                        </div>
                </Form>
            </Page>
        </div>
    )
}

const MemoizedUserAddForm = React.memo(UserAddForm);

export default showSecondarySidebar(false)(MemoizedUserAddForm);